import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select, Switch } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState } from '@common/components';
import { CertificationTypes } from 'works/graphql/works-list-item-template';
import ExpirationTypeSelect from './expiration-type-select';

export default function FormCertificationTemplate({
  handleSubmit,
  initialValues,
  showExpiration,
  form,
}) {
  const { loading, error, data } = useQuery(CertificationTypes);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorHandler error={error} log="FormCertificationTemplate" />;
  }

  const handleCertificationSelect = (value, { children }) => {
    form.setFieldsValue({ name: children });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={initialValues}
    >
      <Form.Item label="Active" name="active" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        label="Certification Type"
        name="certificationId"
        rules={[{ required: true, message: 'Select a document type' }]}
      >
        <Select
          size="large"
          showSearch
          onChange={handleCertificationSelect}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {(data.certificationList || []).map(({ id, credential, name }) => (
            <Select.Option key={id} value={id}>
              {`${credential} - ${name}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter a item name' }]}
      >
        <Input size="large" />
      </Form.Item>

      {showExpiration && <ExpirationTypeSelect form={form} />}

      <Form.Item label="Description" name="description">
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
}

FormCertificationTemplate.propTypes = {
  initialValues: PropTypes.shape({
    active: PropTypes.bool,
    certificationId: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  showExpiration: PropTypes.bool,
};

FormCertificationTemplate.defaultProps = {
  showExpiration: false,
};
